/* Mrays — repair-quote.html: pick services for the chosen device, see a
   running estimate, book straight to WhatsApp with the full list attached. */

(function () {
  'use strict';

  var ICON_SVG = {
    screen: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9 7l6 8M15 7l-6 8" stroke="currentColor" stroke-width="1.5"/></svg>',
    battery: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="7" width="16" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M21 10.5v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M6 12h6" stroke="currentColor" stroke-width="1.5"/></svg>',
    camera: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="4" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M3 8.5h4l1.5-2.5h7L17 8.5h4v10H3z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    liquid: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3s6 6.2 6 10a6 6 0 0 1-12 0c0-3.8 6-10 6-10z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    board: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M10 3v4M14 3v4M10 17v4M14 17v4M3 10h4M3 14h4M17 10h4M17 14h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    software: '<svg viewBox="0 0 24 24" aria-hidden="true"><ellipse cx="12" cy="6" rx="7.5" ry="3" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M4.5 6v12c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3V6" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M4.5 12c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
    charging: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="14" width="16" height="7" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9 14v-2.5a3 3 0 0 1 6 0V14" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M12 3v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    speaker: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    receiver: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9.5 6.5h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    mic: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="2.5" width="6" height="11" rx="3" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    backpanel: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="10" cy="7" r="1.8" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M8 17h8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    proximity: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="12" cy="6.5" r="1.2" fill="currentColor"/><path d="M15.5 5a4.5 4.5 0 0 1 0 3M18 3.5a7.5 7.5 0 0 1 0 6" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
    auxjack: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5v11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><rect x="9.5" y="13.5" width="5" height="6" rx="1.4" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M9.5 6.5h5M9.5 9.5h5" stroke="currentColor" stroke-width="1.3"/><path d="M12 19.5v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    cleaning: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3.5h6l1 7H8z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M8 10.5h8v4a4 4 0 0 1-8 0z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 18.5v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };

  var root = document.getElementById('rbRoot');
  var servicesDataEl = document.getElementById('rb-services-data');
  var RAW_SERVICES = servicesDataEl ? JSON.parse(servicesDataEl.textContent) : [];
  // Priced per device further down. The section's own price_from is now only a
  // label source — every model used to quote the same six numbers whatever phone
  // it was, which put an iPhone 13 Pro Max screen at ₹2,799 against a real
  // ₹19,999.
  var SERVICES = [];
  var backPath = (root && root.dataset.backPath) || '/pages/repair';
  var waNumber = (root && root.dataset.whatsapp) || '918712307510';
  // The shop's own name, so the message reads as addressed to them rather than
  // to a name baked into the theme's JavaScript.
  var businessName = (root && root.dataset.business) || 'Mrays';

  function cdnWidth(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  var params = new URLSearchParams(window.location.search);
  var brand = params.get('brand');
  var model = params.get('model');

  if (typeof MODELS_BY_BRAND === 'undefined' || !brand || !model || !MODELS_BY_BRAND[brand] || MODELS_BY_BRAND[brand].indexOf(model) === -1) {
    root.innerHTML =
      '<div class="post__missing">' +
        '<p class="eyebrow">Repair builder</p>' +
        '<h1 class="h2">That device isn’t in our list.</h1>' +
        '<p>The link might be old. Head back and pick your brand and model again.</p>' +
        '<a class="btn btn--lime" href="' + backPath + '">Select your device</a>' +
      '</div>';
    return;
  }

  document.title = model + ' repair — Mrays';

  // Now that the device is known, price each service for this exact model.
  // A null price means Cashify doesn't quote this repair for this device, so we
  // have no real figure — the row says "Get a quote" instead of a number. The
  // section's own price_from is no longer used as a fallback: it was a generic
  // guess, and guessing is what put an iPhone 13 Pro Max screen at ₹2,799.
  SERVICES = RAW_SERVICES.map(function (s) {
    var price = (typeof servicePrice === 'function')
      ? servicePrice(brand, model, s.key)
      : null;
    return { key: s.key, label: s.label, from: price, icon: ICON_SVG[s.icon] || ICON_SVG.screen };
  });

  function money(n) { return '₹' + n.toLocaleString('en-IN'); }
  function priceLabel(n) { return (n == null) ? 'Get a quote' : 'from ' + money(n); }

  var selectedServices = {};

  // The section already rendered the layout. Fill in the parts that depend on
  // the query string rather than rebuilding the page — rewriting root.innerHTML
  // here is what made opening a model flash "Loading…" and then redraw.
  var rbList = document.getElementById('rbList');
  var rbSummaryList = document.getElementById('rbSummaryList');
  var rbEmpty = document.getElementById('rbEmpty');
  var rbTotal = document.getElementById('rbTotal');
  var rbTotalAmount = document.getElementById('rbTotalAmount');

  var back = document.getElementById('rbBack');
  if (back) back.href = backPath + '?brand=' + encodeURIComponent(brand);

  var photo = modelPhoto(brand, model);
  var img = document.getElementById('rbDeviceImg');
  if (img) {
    // 264px is the natural width of a model photo, so 320/640 asked the CDN
    // for an upscale it can't do and the browser stretched what it got. The
    // card is sized to match the source instead — a crisp 132px beats a soft
    // 180px, which is the same call the picker grid already makes.
    img.src = cdnWidth(photo, 264);
    img.alt = model;
    img.setAttribute('onerror', "modelPhotoFallback(this, '" + brand + "')");
  }
  var nameEl = document.getElementById('rbDeviceName');
  if (nameEl) nameEl.textContent = model + ' · ' + BRAND_LABEL[brand];

  // Icons are injected rather than inlined 11 times in Liquid, and the prices
  // swap from the section's generic fallback to this model's real figure.
  SERVICES.forEach(function (s) {
    var slot = rbList.querySelector('[data-icon="' + s.key + '"]');
    if (slot) slot.innerHTML = s.icon;
    var price = rbList.querySelector('[data-price-for="' + s.key + '"]');
    if (price) price.textContent = priceLabel(s.from);
  });

  function renderSummary() {
    var keys = Object.keys(selectedServices);
    if (!keys.length) {
      rbSummaryList.innerHTML = '';
      rbEmpty.hidden = false;
      rbTotal.hidden = true;
      return;
    }
    rbEmpty.hidden = true;
    rbTotal.hidden = false;
    var total = 0, quoted = false;
    rbSummaryList.innerHTML = keys.map(function (key) {
      var s = selectedServices[key];
      if (s.from != null) total += s.from; else quoted = true;
      return '<li><span>' + s.label + '</span><b>' + priceLabel(s.from) + '</b></li>';
    }).join('');
    // A quote-only service can't be added up, so the total says "+ quote" rather
    // than silently under-reporting the job.
    rbTotalAmount.textContent = total ? (money(total) + (quoted ? '+ & quote' : '+'))
                                      : 'On quote';
  }

  rbList.addEventListener('click', function (e) {
    var btn = e.target.closest('.repairbuilder__add');
    if (!btn) return;
    var key = btn.dataset.key;
    var service = SERVICES.filter(function (s) { return s.key === key; })[0];

    if (selectedServices[key]) {
      delete selectedServices[key];
      btn.classList.remove('is-added');
      btn.textContent = 'Add +';
    } else {
      selectedServices[key] = service;
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
    }
    renderSummary();
  });

  document.getElementById('rbBook').addEventListener('click', function () {
    var keys = Object.keys(selectedServices);

    // The faults are the whole point of the message — the shop has to be able
    // to price the job from it without asking anything back. So each one gets
    // its own line with the figure the customer was shown, plus the running
    // total and the exact quote URL, rather than a bare comma-joined list.
    var lines = ['Hi ' + businessName + ', I’d like to book a repair.', ''];
    lines.push('Device: ' + model + ' (' + BRAND_LABEL[brand] + ')');

    if (keys.length) {
      var total = 0, anyQuote = false;
      lines.push('', keys.length === 1 ? 'Problem:' : 'Problems:');
      keys.forEach(function (k) {
        var s = selectedServices[k];
        if (s.from != null) total += s.from; else anyQuote = true;
        lines.push('• ' + s.label + ' — ' + priceLabel(s.from));
      });
      if (total) lines.push('', 'Estimated total: ' + money(total) + (anyQuote ? '+ plus the quoted items' : '+'));
    } else {
      lines.push('', 'I’m not sure what’s wrong — can you take a look?');
    }

    lines.push('', 'Quote: ' + window.location.href);

    var waUrl = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(lines.join('\n'));
    window.open(waUrl, '_blank', 'noopener');
  });

  // Arriving from a services-rail card: that repair is already chosen, so open
  // with it added and the estimate showing rather than an empty summary the
  // customer has to fill in again. "lcd" is the same bench job as "screen" on
  // this page, so it maps across rather than falling through to nothing.
  var issue = params.get('issue');
  if (issue === 'lcd') issue = 'screen';
  if (issue) {
    var preset = SERVICES.filter(function (s) { return s.key === issue; })[0];
    if (preset) {
      selectedServices[preset.key] = preset;
      var presetBtn = rbList.querySelector('.repairbuilder__add[data-key="' + preset.key + '"]');
      if (presetBtn) {
        presetBtn.classList.add('is-added');
        presetBtn.textContent = 'Added ✓';
      }
      var presetItem = presetBtn && presetBtn.closest('.repairbuilder__item');
      if (presetItem) presetItem.classList.add('is-preselected');
      renderSummary();
    }
  }

  if (window.mraysRevive) window.mraysRevive();
})();
